<template>
  <div class="HNIS">
    <div class="page_img">
      <img src="@/assets/img/hnis_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="font_shadow page_summary">远程手术诊疗系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/hnis_main.png" alt="">
      <div class="main_explain hnis_explain">通过“面对面”与异地医生开展交互式咨询、病例讨论，提升工作效率。通过移动端接入方式进行数据分析以及病例诊断实施远程手术。大大节省了医疗资源</div>
    </div>
    <div class="sys_back"><img src="@/assets/img/solution_back2.png" alt=""></div>
    <div class="system flex_column">
      <div class="sys_main">
        <img src="@/assets/img/hnis_main1.png" alt="">
      </div>
      <div class="sys_main1">
        <img src="@/assets/img/hnis_main2.jpg" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'HNIS',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
    }
  },
  created() {
  },
}
</script>

<style scoped lang="scss">
.HNIS {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    margin-bottom: 0.5rem;
    img {
      width: 50%;
    }
    .hnis_explain {
      margin-top: 1rem;
      font-weight: 500;
      width: 65%;
      padding: 0.2rem 0.3rem;
      font-size: 0.19rem;
    }
  }
  .container {
    margin-bottom: 1.3rem;
    flex-wrap: wrap;
    .container_item {
      width: 20%;
      flex-direction: column;
      margin-top: 0.55rem;
      img {
        width: 80%;
      }
      span {
        margin-top:	0.1rem;
        font-size: 0.22rem;
        font-weight: bold;
      }
    }
  }
  .sys_back {
    position: relative;
    width: 100%;
    img {
      opacity: 0.15;
      position: absolute;
      width: 100%;
      left: 50%;
      transform: translate(-50%,-5%);
      z-index: -1;
    }
  }
  .system {
    margin-bottom: 1.9rem;
    .sys_main {
      img {
        width: 70%;
      }
    }
    .sys_main1 {
      img {
        width: 100%;
      }
    }
  }

}
</style>
